import React from 'react';

import CustomBlock from 'uicontainers/apps/survey/CustomBlock';

const Screened = () => {
  return <CustomBlock />;
};

export default Screened;
